import React from "react";
import { Link } from "react-router-dom";
import { useLang } from "../context/LanguageContext";

export function Footer() {
  const { t } = useLang();
  return (
    <footer className="mt-20 border-t border-slate-200 bg-slate-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid gap-8 md:grid-cols-4">
          <div className="md:col-span-1">
            <img src="/logo.webp" alt="GetJobs.Today" className="h-8" />
            <p className="mt-3 text-sm text-slate-500">{t("footer_tagline")}</p>
          </div>
          <div>
            <h4 className="font-display text-sm font-bold text-navy">Candidates</h4>
            <ul className="mt-3 space-y-2 text-sm text-slate-500">
              <li><Link to="/jobs" className="hover:text-brand-blue">Find Jobs</Link></li>
              <li><Link to="/jobs?work_mode=remote" className="hover:text-brand-blue">Remote Jobs</Link></li>
              <li><Link to="/jobs?employment_type=freelance" className="hover:text-brand-blue">Freelance Jobs</Link></li>
              <li><Link to="/signup" className="hover:text-brand-blue">{t("free_for_life")}</Link></li>
            </ul>
          </div>
          <div>
            <h4 className="font-display text-sm font-bold text-navy">Employers</h4>
            <ul className="mt-3 space-y-2 text-sm text-slate-500">
              <li><Link to="/find-people" className="hover:text-brand-blue">Find People</Link></li>
              <li><Link to="/signup?role=employer" className="hover:text-brand-blue">Post a Job</Link></li>
              <li><Link to="/how-it-works" className="hover:text-brand-blue">Pricing</Link></li>
            </ul>
          </div>
          <div>
            <h4 className="font-display text-sm font-bold text-navy">Company</h4>
            <ul className="mt-3 space-y-2 text-sm text-slate-500">
              <li><Link to="/how-it-works" className="hover:text-brand-blue">How it works</Link></li>
              <li><span className="cursor-default">Privacy</span></li>
              <li><span className="cursor-default">Terms</span></li>
            </ul>
          </div>
        </div>
        <div className="mt-10 border-t border-slate-200 pt-6 text-center text-xs text-slate-400">
          <p className="font-semibold text-navy">{t("candidates_free")} · {t("employers_free")}</p>
          <p className="mt-2">© {new Date().getFullYear()} GetJobs.Today — {t("footer_tagline")}</p>
        </div>
      </div>
    </footer>
  );
}
